import { ApplicationConfig, DEFAULT_CURRENCY_CODE, inject, LOCALE_ID, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { registerLocaleData } from '@angular/common';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import localeFr from '@angular/common/locales/fr';
import { MessageService } from 'primeng/api';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { KeycloakService } from './services/keycloak.service';
import { authInterceptor } from './interceptors/auth.interceptor';
import { moderatorInterceptor } from './interceptors/moderator.interceptor';

registerLocaleData(localeFr)

function initializeKeycloak(): () => Promise<boolean> {
  return async () => await inject(KeycloakService).init();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(initializeKeycloak()),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    }),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, moderatorInterceptor])
    ),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    MessageService,
  ]
};
